var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    attrs: {
      "max-width": "1280"
    }
  }, [_c('v-row', {
    staticClass: "mt-3 mt-md-8 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0 headline text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.$route.params._cp ? _c('span', [_vm._v("CP 상세")]) : _c('span', [_vm._v("CP 생성")])]), _c('v-spacer')], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0 pr-md-1",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    staticClass: "mx-1"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "아이디",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.username,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "username", $$v);
      },
      expression: "cp.username"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-password-field', {
    attrs: {
      "label": "비밀번호",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.password,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "password", $$v);
      },
      expression: "cp.password"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "cp Key",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.cpKey,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "cpKey", $$v);
      },
      expression: "cp.cpKey"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  })], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "업체명",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.name,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "name", $$v);
      },
      expression: "cp.name"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "연락처",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.phone,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "phone", $$v);
      },
      expression: "cp.phone"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "이메일",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.email,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "email", $$v);
      },
      expression: "cp.email"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "우편번호",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.postcode,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "postcode", $$v);
      },
      expression: "cp.postcode"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  })], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "기본주소",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.address1,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "address1", $$v);
      },
      expression: "cp.address1"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "상세주소",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.address2,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "address2", $$v);
      },
      expression: "cp.address2"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "noti url",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.noti,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "noti", $$v);
      },
      expression: "cp.noti"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "ci",
      "placeholder": " ",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.ci,
      callback: function ($$v) {
        _vm.$set(_vm.cp, "ci", $$v);
      },
      expression: "cp.ci"
    }
  })], 1)], 1)], 1), _c('v-card-actions')], 1), _c('v-card', {
    staticClass: "mx-1 mt-4"
  }, [_c('v-card-text', [_c('div', {
    staticClass: "subtitle-1 pt-4 d-flex"
  }, [_c('strong', [_vm._v("CP 등급")])]), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.giftcardLevels,
      "item-text": "text",
      "item-value": "value",
      "label": "등급",
      "placeholder": " "
    },
    model: {
      value: _vm.cp.riskManagement.giftcard.level,
      callback: function ($$v) {
        _vm.$set(_vm.cp.riskManagement.giftcard, "level", $$v);
      },
      expression: "cp.riskManagement.giftcard.level"
    }
  })], 1)], 1), _c('div', {
    staticClass: "subtitle-1 pt-4 d-flex"
  }, [_c('strong', [_vm._v("발행 금액 제한")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.riskManagement.giftcard.limitEnabled,
      callback: function ($$v) {
        _vm.$set(_vm.cp.riskManagement.giftcard, "limitEnabled", $$v);
      },
      expression: "cp.riskManagement.giftcard.limitEnabled"
    }
  })], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "발행 금액 제한(일간)",
      "type": "number",
      "placeholder": " ",
      "disabled": !_vm.cp.riskManagement.giftcard.limitEnabled,
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.riskManagement.giftcard.dailyLimit,
      callback: function ($$v) {
        _vm.$set(_vm.cp.riskManagement.giftcard, "dailyLimit", $$v);
      },
      expression: "cp.riskManagement.giftcard.dailyLimit"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "발행 금액 제한(월간)",
      "type": "number",
      "placeholder": " ",
      "disabled": !_vm.cp.riskManagement.giftcard.limitEnabled,
      "clearable": "",
      "outlined": "",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.riskManagement.giftcard.monthlyLimit,
      callback: function ($$v) {
        _vm.$set(_vm.cp.riskManagement.giftcard, "monthlyLimit", $$v);
      },
      expression: "cp.riskManagement.giftcard.monthlyLimit"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "subtitle-1 pt-4"
  }, [_c('strong', [_vm._v("관리자 알람")])]), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "잔여 알람금액(1차)",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.createComma(_vm.cp.riskManagement.giftcard.alarmPrices[0], 0);
      }
    },
    model: {
      value: _vm.cp.riskManagement.giftcard.alarmPrices[0],
      callback: function ($$v) {
        _vm.$set(_vm.cp.riskManagement.giftcard.alarmPrices, 0, $$v);
      },
      expression: "cp.riskManagement.giftcard.alarmPrices[0]"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "잔여 알람금액(2차)",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.createComma(_vm.cp.riskManagement.giftcard.alarmPrices[1], 1);
      }
    },
    model: {
      value: _vm.cp.riskManagement.giftcard.alarmPrices[1],
      callback: function ($$v) {
        _vm.$set(_vm.cp.riskManagement.giftcard.alarmPrices, 1, $$v);
      },
      expression: "cp.riskManagement.giftcard.alarmPrices[1]"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "잔여 알람금액(3차)",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.createComma(_vm.cp.riskManagement.giftcard.alarmPrices[2], 2);
      }
    },
    model: {
      value: _vm.cp.riskManagement.giftcard.alarmPrices[2],
      callback: function ($$v) {
        _vm.$set(_vm.cp.riskManagement.giftcard.alarmPrices, 2, $$v);
      },
      expression: "cp.riskManagement.giftcard.alarmPrices[2]"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "잔여 알람금액(4차)",
      "placeholder": " ",
      "clearable": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.createComma(_vm.cp.riskManagement.giftcard.alarmPrices[3], 3);
      }
    },
    model: {
      value: _vm.cp.riskManagement.giftcard.alarmPrices[3],
      callback: function ($$v) {
        _vm.$set(_vm.cp.riskManagement.giftcard.alarmPrices, 3, $$v);
      },
      expression: "cp.riskManagement.giftcard.alarmPrices[3]"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6",
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pr-1"
  }, [_c('v-text-field', {
    attrs: {
      "label": "담당자 이름",
      "placeholder": " ",
      "hide-details": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": ""
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c('v-col', {
    staticClass: "pl-1"
  }, [_c('v-text-field', {
    attrs: {
      "label": "알람 연락처",
      "placeholder": " ",
      "hide-details": "",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "dense": ""
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return function () {
          _vm.cp.riskManagement.alarmPhones.push(_vm.phone);
          _vm.phone = '';
        }.apply(null, arguments);
      }
    },
    model: {
      value: _vm.phone,
      callback: function ($$v) {
        _vm.phone = $$v;
      },
      expression: "phone"
    }
  })], 1), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function () {
        _vm.cp.riskManagement.giftcard.alarmPhones.push(_vm.phone), _vm.cp.riskManagement.giftcard.alarmNames[_vm.cp.riskManagement.giftcard.alarmPhones.length - 1] = _vm.name, _vm.phone = '', _vm.name = '';
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "20"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1)], 1)], 1), _c('v-row', _vm._l(_vm.cp.riskManagement.giftcard.alarmPhones, function (alarmPhone, index) {
    return _c('v-col', {
      key: index,
      staticClass: "pr-1",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-chip', {
      attrs: {
        "close": "",
        "color": "secondary"
      },
      on: {
        "click:close": function ($event) {
          _vm.cp.riskManagement.giftcard.alarmPhones.splice(index, 1), _vm.cp.riskManagement.giftcard.alarmNames.splice(index, 1);
        }
      }
    }, [_vm._v(_vm._s(_vm.cp.riskManagement.giftcard.alarmNames[index]) + " " + _vm._s(alarmPhone))])], 1);
  }), 1), _c('v-textarea', {
    staticClass: "mt-4",
    attrs: {
      "label": "알람 메시지",
      "placeholder": " ",
      "outlined": "",
      "color": "secondary",
      "background-color": "white",
      "hide-details": ""
    },
    model: {
      value: _vm.cp.riskManagement.giftcard.alarmMessage,
      callback: function ($$v) {
        _vm.$set(_vm.cp.riskManagement.giftcard, "alarmMessage", $$v);
      },
      expression: "cp.riskManagement.giftcard.alarmMessage"
    }
  })], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "my-6"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }